import { useIncrementalQuery } from '~/queries';
import { GetQuizSessionsOptions } from '~/monolith-api';
import { getQuizSessionsFromClient } from '~/pages/api/quizzes';
import { RegisteredQueryKeys } from '~/queries/RegisteredQueryKeys';

export const getQuizSessionsKey = (): RegisteredQueryKeys => 'get-quiz-sessions';

export function useGetQuizSessions(options?: GetQuizSessionsOptions) {
   return useIncrementalQuery([getQuizSessionsKey(), options], async page => {
      let { quizSessions: data, hasMore } = await getQuizSessionsFromClient({
         ...options,
         offset: page,
      });
      return { page, data, hasMore };
   });
}
